// extracted by mini-css-extract-plugin
module.exports = {"cardShadow":"cardPanelView_cardShadow__5F7G8"};